import React from 'react';
import { FiX, FiZap } from 'react-icons/fi';
import { Tier } from '../api/paymentsApi';
import './UpgradeModal.css';

interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
  requiredTier: Tier | null;
  featureLabel: string;
  onSubscribe: () => void;
  onPayPerItem?: () => void;
}

// Shown when a free user attempts a locked option. Offers subscription or a
// one-off pay-per-item unlock (the latter pending PaymentsService support).
export default function UpgradeModal({
  open,
  onClose,
  requiredTier,
  featureLabel,
  onSubscribe,
  onPayPerItem,
}: UpgradeModalProps) {
  if (!open) return null;
  const tierLabel = requiredTier === 'pro' ? 'Pro' : 'Basic';

  return (
    <div className="upgrade-overlay" role="dialog" aria-modal="true" aria-label="Upgrade required" onClick={onClose}>
      <div className="upgrade-card" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-close" onClick={onClose} aria-label="Close">
          <FiX />
        </button>
        <div className="upgrade-icon">
          <FiZap />
        </div>
        <h2 className="upgrade-title">{featureLabel} is a premium feature</h2>
        <p className="upgrade-body">
          Basic podcasts are free. Upgrade to <strong>{tierLabel}</strong> to unlock {featureLabel.toLowerCase()},
          remove ads, and generate more — or unlock just this one with a single purchase.
        </p>
        <div className="upgrade-actions">
          <button className="btn btn--primary btn--block btn--lg" onClick={onSubscribe}>
            Upgrade to {tierLabel}
          </button>
          <button className="btn btn--ghost btn--block" onClick={onPayPerItem} disabled={!onPayPerItem}>
            Unlock just this one
          </button>
        </div>
        <p className="upgrade-fine">Cancel anytime. Ad-free with any paid plan.</p>
      </div>
    </div>
  );
}
